import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
// import Animation from "./Components/Animation/Animation";
import NewNav from "./Components/Navbar/NewNav"
import "./style.css"
import Home from "./Components/Content/Home/Home"
import Team from "./Components/Content/Team/Team"
import Achievements from "./Components/Content/Achievements/Achievements"
import Projects from "./Components/Content/Project/Project"
import Events from "./Components/Content/Events/Events"
import Workshops from "./Components/Content/Workshops/Workshops"

import Gallery from "./Components/Content/Gallery/Gallery"
import Technex from "./Components/Content/Technex/Technex"
import Footer from "./Components/Footer/Footer"
import NotFound from "./Components/404/NotFound"

// team page routes
import ContentTeam from "./Components/Content/Team/TeamPage/ContentTeamPage"
import ProjectTeam from "./Components/Content/Team/TeamPage/ProjectTeamPage"
import DesignTeam from "./Components/Content/Team/TeamPage/DesignTeamPage"
import EventTeam from "./Components/Content/Team/TeamPage/EventTeamPage"
import MediaTeam from "./Components/Content/Team/TeamPage/MediaTeamPage"
import TechTeam from "./Components/Content/Team/TeamPage/TechTeamPage"

// project details routes
import MalarAI from "./Components/Content/Project/ProjectDetails/MalarAI/MalarAI"
import Augnex from "./Components/Content/Project/ProjectDetails/Augnex/Augnex"

const App = () => {
  // Yo  whatUp Guys
  // const [pages, setPages] = React.useState({
  //   home: true,
  //   team: false,
  //   projects: false,
  //   achievements: false,
  //   events: false,
  // });

  // const pageChangeHandler = (page) => {
  //   setPages(() => {
  //     return {
  //       home: true ? false : true,
  //       team: true ? false : true,
  //       projects: true ? false : true,
  //       achievements: true ? false : true,
  //       events: true ? false : true,
  //      ,
  //     };
  //   });
  // };

  // const [showAnimation, setShowAnimation] = React.useState(true);

  // React.useEffect(() => {
  //   setTimeout(() => {
  //     setShowAnimation(false);
  //   }, 4000);
  // }, []);

  return (
    <Router>
      {/* {showAnimation && <Animation/>} */}
      {/* {!showAnimation && <NewNav/>} */}
      <NewNav />
      {/* <Navbar /> */}
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/team" element={<Team />} />
        <Route exact path="/achievements" element={<Achievements />} />
        <Route exact path="/projects" element={<Projects />} />
        <Route exact path="/events" element={<Events />} />
        <Route exact path="/workshops" element={<Workshops />} />
        <Route exact path="/gallery" element={<Gallery />} />
        <Route exact path="/technex" element={<Technex />} />
        <Route exact path="*" element={<NotFound />} />

        {/* Team Page Routes */}
        <Route exact path="/team/content_team" element={<ContentTeam />} />
        <Route exact path="/team/project_team" element={<ProjectTeam />} />
        <Route exact path="/team/design_team" element={<DesignTeam />} />
        <Route exact path="/team/event_team" element={<EventTeam />} />
        <Route exact path="/team/media_team" element={<MediaTeam />} />
        <Route exact path="/team/tech_team" element={<TechTeam />} />

        <Route exact path="/projects/Malar-AI" element={<MalarAI />} />
        <Route exact path="/projects/Augnex" element={<Augnex />} />
      </Routes>
      {/* {!showAnimation && <Footer/>} */}
      <Footer />
    </Router>
  )
}

export default App
